<template>
    <ion-row>
        <ion-col size-md="9" size-xs="12">
            <ion-card>
                <ion-card-header>
                    <ion-card-title>{{ $t('ncrypt.vault.title') }}</ion-card-title>
                </ion-card-header>
                <ion-card-content>
                    <ion-text>{{ $t('ncrypt.vault.intro') }}</ion-text>
                </ion-card-content>
            </ion-card>
        </ion-col>
        <ion-col size-md="3" size-xs="12" style="display: flex; align-items: stretch;">
            <ion-card style="flex: 1;">
                <ion-card-header>
                    <ion-card-title>{{ $t('ncrypt.vault.usage') }}</ion-card-title>
                </ion-card-header>
                <ion-card-content>
                    <div>
                        <ion-text>{{ usedSizeReadable }} / {{ availableSizeReadable }}</ion-text>
                    </div>
                    <div>
                        <ion-text>{{ files.length }} / {{ filesAmountLimit >= 0 ? filesAmountLimit : $t('ncrypt.unlimited') }} {{ $t('ncrypt.files') }}</ion-text>
                    </div>
                </ion-card-content>
            </ion-card>
        </ion-col>
    </ion-row>
</template>

<script>
    export default {
        name: "VaultHeader",
        props: {
            files: {type: Array},
            filesAmountLimit: {type: Number},
            usedSize: {type: Number},
            usedSizeReadable: {type: String},
            availableSize: {type: Number},
            availableSizeReadable: {type: String},
        },
    }
</script>
